import { useSettings } from '@wu/widget-core';
import { devicesDisplayOptions } from '../constants';
import type { Device } from '../types';

function isDisplayedOnAllDevices(displayDevices: Device[]) {
  if (!Array.isArray(displayDevices)) {
    return false;
  }

  for (let i = 0; i < devicesDisplayOptions.length; i++) {
    if (!displayDevices.includes(devicesDisplayOptions[i].value)) {
      return false;
    }
  }

  return true;
}

export function useIsAPISchemaTimeoutEnabled() {
  const {
    triggerExitIntentEnabled,
    triggerPageLoadEnabled,
    triggerTimeOnPageEnabled,
    triggerScrollEnabled,
    triggerScrollToElementEnabled,
    triggerClickEnabled,
    displayFrequency,
    displayPages,
    displayDevices,
    schedule
  } = useSettings();

  return (
    triggerPageLoadEnabled &&
    !(
      triggerExitIntentEnabled ||
      triggerTimeOnPageEnabled ||
      triggerScrollEnabled ||
      triggerScrollToElementEnabled ||
      triggerClickEnabled ||
      triggerClickEnabled ||
      displayFrequency !== 'everytime' ||
      displayPages !== 'allPages' ||
      schedule ||
      !isDisplayedOnAllDevices(displayDevices)
    )
  );
}
